<div class="container mt-4">
    <form (ngSubmit)="reassignForm.form.valid && onSubmit()" #reassignForm="ngForm">

        <div class="form-row">
            <div class="form-group col-md-6">
                <label for="advisorfrom">Operador Comercial (De)</label>
                <select class="form-control" id="advisorfrom" name="advisorfrom" [(ngModel)]="model.advisorFromId"
                    required>
                    <option value="">-- Seleccione --</option>
                    <option *ngFor="let item of advisors" [value]="item.id">
                        {{ item.name }}
                    </option>
                </select>
            </div>

            <div class="form-group col-md-6">
                <label for="advisorto">Operador Comercial (Para)</label>
                <select class="form-control" id="advisorto" name="advisorto" [(ngModel)]="model.advisorToId" required>
                    <option value="">-- Seleccione --</option>
                    <option *ngFor="let item of advisors" [value]="item.id">
                        {{ item.name }}
                    </option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <label for="observation">Observaciones</label>
            <textarea class="form-control" id="observation" name="observation" rows="3" style="resize: none;"
                [(ngModel)]="model.observation">
        </textarea>
        </div>

        <hr />

        <div class="text-right">
            <button type="submit" class="btn btn-sm btn-success ml-1" [disabled]="!reassignForm.valid">
                Guardar
            </button>
        </div>

    </form>
</div>